export const SEARCH_MIN_LENGTH = 3
export const SEARCH_DEBOUNCE_MS = 1000
